// extracted by mini-css-extract-plugin
module.exports = {"container":"share_container__ZqC0Z","top":"share_top__1XLdA","icons":"share_icons__3SZYy"};